module.exports = __webpack_public_path__ + "static/media/collect.0927acf7.png";